/* École active du sélecteur de rôle (teacher/direction multi-école). Clé */
/* globale (pas par uid) : `lib/api.ts` la lit en dehors de tout contexte */
/* React pour construire le header `x-active-school-id` à chaque requête. */
/* `use-roles.tsx` reste la seule source qui l'écrit. */

const KEY = 'naia.activeSchoolId';

export function getActiveSchoolId(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setActiveSchoolId(schoolId: string | null): void {
  try {
    if (schoolId) localStorage.setItem(KEY, schoolId);
    else localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
